module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-110\">Row background</label> \r\n        <div class=\"nopadding label-90\">\r\n            <input id=\"tableRowColor1Picker\" name=\"tableRowColor1Picker\" type=\"color\" value=\"")
    ; __append(escapeFn( normalRowBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableRowColor1\" name=\"tableRowColor1\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( normalRowBgColor ))
    ; __append("\" />\r\n        </div>\r\n    </div> \r\n\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-110\">Row background</label> \r\n        <div class=\"nopadding label-90\">\r\n            <input id=\"tableRowColor2Picker\" name=\"tableRowColor2Picker\" type=\"color\" value=\"")
    ; __append(escapeFn( alternateRowBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"tableRowColor2\" name=\"tableRowColor2\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( alternateRowBgColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>  \r\n</div>")
  }
  return __output;

}